"use client";

import { useCallback, useState } from "react";

/**
 * Tracks which `new_event` cards in the activity feed are currently
 * expanded. Returns the Set itself (not a boolean per id) so the same
 * reference can be passed down to memoized rows; cards check
 * `expandedEvents.has(event.id)` instead of receiving a boolean prop
 * that would change identity on every re-render.
 */
export function useExpandedEvents() {
  const [expandedEvents, setExpandedEvents] = useState<Set<string>>(new Set());

  const toggleEventExpansion = useCallback((eventId: string) => {
    setExpandedEvents((prev) => {
      const next = new Set(prev);
      if (next.has(eventId)) {
        next.delete(eventId);
      } else {
        next.add(eventId);
      }
      return next;
    });
  }, []);

  return { expandedEvents, toggleEventExpansion };
}
